import { Box, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles({
  contentHolder: {
    padding: "5% 25% 25% 25%",
  },
  box: {
    background: "#FFFFFF",
    border: "1px solid #DCDCDC",
    boxSizing: "border-box",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.08)",
    borderRadius: "16px",
    padding: "5%",
  },
  header: {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "28px",
    lineHeight: "34px",
  },
  paragraph: {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "19px",
  },
});

const CookiesBlocker = () => {
  const classes = useStyles();

  return (
    <Box className={classes.contentHolder}>
      <Grid container columnSpacing={6} rowSpacing={1} className={classes.box}>
        <Grid item xs={12} className={classes.header}>
          Adjust your Privacy settings
        </Grid>
        <Grid item xs={12} className={classes.paragraph}>
          You will need to enable cookies in your browser to continue.
          <br />
          <br />
          Cookies can be enabled in your browser’s privacy settings.
        </Grid>
      </Grid>
    </Box>
  );
};

export default CookiesBlocker;
